// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YV44","icon":"styles_icon__DyJPv"};